import React, { useState, lazy, Suspense, memo, useContext} from 'react';
import { SttTabs, SttTranslateHook } from '@stt-componentes/core-v2';
import { Funcionalidade } from '@stt-gestao-pacs/util';
import { usuarioSignal } from '../../../signals/usuario';
import { useSignals } from '@preact/signals-react/runtime';
import { Paper } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    wrapper: {
        padding: theme.spacing(1)
    }
}));

const Atividades = lazy(() => import('./atividades/componentes/Grid'));
const IntegracaoExames = lazy(() => import('./integracao-exames/IntegracaoExames'));
const Invalidacao = lazy(() => import('./invalidacao/Invalidacao'));
const Comandos = lazy(() => import('./comandos/Comandos'));

const AtividadesSuspense = memo((props) => (
    <Suspense>
        <Paper elevation={0} style={{ padding: 16, boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}>
            <Atividades {...props} />
        </Paper>
    </Suspense>
));

const IntegracaoExamesSuspense = memo((props) => {
   return (
       <Suspense>
           <IntegracaoExames {...props} />
       </Suspense>
   );
});

const InvalidacaoSuspense = memo((props) => {
   return (
       <Suspense>
           <Invalidacao {...props} />
       </Suspense>
   );
});

const ComandosSuspense = memo((props) => {
   return (
       <Suspense>
           <Comandos {...props} />
       </Suspense>
   );
});

const IndexNotificacoes = ({ props }) => {
   useSignals();
   const rbac = usuarioSignal.value.rbac;
   const { strings } = useContext(SttTranslateHook.I18nContext);
   const classes = useStyles();

   const abas = [
       {
           titulo: strings.atividades || 'Atividades',
           conteudo: AtividadesSuspense,
           key: 'AtividadesSuspense',
           permanente: true,
           funcionalidade: Funcionalidade.ABA_ATIVIDADES,
       },
       {
           titulo: strings.comandos,
           conteudo: ComandosSuspense,
           key: 'ComandosSuspense',
           funcionalidade: Funcionalidade.PAGINA_NOTIFICACAO,
           permanente: true,
       },
       {
           titulo: strings.integracaoExames,
           conteudo: IntegracaoExamesSuspense,
           key: 'IntegracaoExamesSuspense',
           funcionalidade: Funcionalidade.PAGINA_NOTIFICACAO,
           permanente: true,
       },
       {
           titulo: strings.invalidacao || 'Invalidação',
           conteudo: InvalidacaoSuspense,
           key: 'InvalidacaoSuspense',
           funcionalidade: Funcionalidade.PAGINA_NOTIFICACAO,
           permanente: true,
       },
   ].filter(({ funcionalidade }) => rbac.temPermissao(funcionalidade));

   const [abaAtiva, setAbaAtiva] = useState('0');

return (
    <SttTabs
        abas={abas}
        className={classes.wrapper}
        canClose={true}
        handleChangeAbaAtiva={setAbaAtiva}
        abaAtiva={abaAtiva}
        permanente={true}
        preload={false}
    />
);
};

export default IndexNotificacoes;
